import { ReactElement, createContext, useState } from 'react'

import { Basin } from '@mediaingenuity/basin-sls/client'

import { getAppConfig } from '@utils/getAppConfig'

interface BasinContextType {
    channel?: Basin
}

export const BasinContext = createContext<BasinContextType>({
    channel: undefined,
})

interface BasinProviderOptions {
    children: ReactElement
    debug?: boolean
    environment: 'production' | 'stage' | 'prod' | 'staging'
}

const dummyBasin = {
    channel: {
        send: () => Promise.resolve(),
        updateMetadata: () => void 0,
        uuids: {
            dailyId: 'dummy-dailyid',
            sessionId: 'dummy-sessionid',
            permanentId: 'dummy-permanentid',
        },
        metadata: {},
        keepalive: true,
    },
} as unknown as { channel: Basin }

export const BasinProvider = ({
    children,
    debug,
    environment,
}: BasinProviderOptions) => {
    const appConfig = getAppConfig()

    const [channel] = useState(() => {
        if (typeof window === 'undefined') {
            return dummyBasin
        }

        try {
            return {
                channel: new Basin({
                    channel: 'TotallyMoney',
                    source: 'Loans',
                    environment: environment,
                    debug:
                        debug ||
                        (typeof window != 'undefined'
                            ? window?.location?.search?.indexOf('debug') > -1
                            : false),
                    metadata: {
                        partner: appConfig.NAME_WHITELABEL,
                    },
                    keepalive: true,
                }),
            }
        } catch (err) {
            return dummyBasin
        }
    })

    return (
        <BasinContext.Provider value={channel}>
            {children}
        </BasinContext.Provider>
    )
}
